var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"micro-single"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('single_value')))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.singleValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }